import { RaptorToastType } from './Toast';

interface ToastColourClasses {
  border: string;
  text: string;
}

export function getToasterColours(type: RaptorToastType): ToastColourClasses {
  switch (type) {
    case 'success':
      return { border: 'border-green-500', text: 'text-green-500' };
    case 'error':
      return { border: 'border-red-500', text: 'text-red-500' };
    case 'warning':
      return { border: 'border-yellow-500', text: 'text-yellow-500' };
    case 'loading':
      return { border: 'border-blue-500', text: 'text-blue-500' };
    case 'link':
      return { border: 'border-green-500', text: 'text-green-500' };
    default:
      return { border: 'border-gray-400', text: 'text-gray-400' };
  }
}
